module.exports = __webpack_public_path__ + "img/electromovilidad.02d787aa.svg";